import * as xlsx from 'xlsx';
import React, { useState, useEffect, useRef } from 'react';

import {
  Box,
  FormControl,
  Select,
  InputLabel,
  MenuItem,
  Divider,
  Button,
  Typography,
  Tabs,
  Tab,
  Stack,
  TextField,
} from '@mui/material';
import { getYears } from '../../utils/constCodeUtils';

import { useDispatch, useSelector } from 'react-redux';
import { treeDeparts } from '../../modules/deptModule/departs';
import { getHqDepart } from '../../utils/baseCodeUtils';
import { useBoolean } from '../../hooks/useBoolean';
import HeadquarterAccountsContainer from './HeadquarterAccountsContainer';
import TeamAccountsContainer from './TeamAccountsContainer';
import EmployeeAccountsContainer from './EmployeeAccountsContainer';
import EmpModalContainer from '../common/form/modal/EmpModalContainer';

//----------------------------------------------------------------------

const TABS = [
  {
    value: 'headquarter',
    label: '본부별',
    content: <HeadquarterAccountsContainer />,
  },
  {
    value: 'team',
    label: '팀별',
    content: <TeamAccountsContainer />,
  },
  {
    value: 'employee',
    label: '팀원',
    content: <EmployeeAccountsContainer />,
  },
];

//----------------------------------------------------------------------

const GroupsAccountsContainer = () => {
  const hqTableRef = useRef();
  const teamTableRef = useRef();
  const headTableRef = useRef();
  const showEmpDialog = useBoolean();

  const dispatch = useDispatch();
  const { departs } = useSelector(({ departModule }) => ({
    departs: departModule.departs.departs,
  }));

  const [selectTab, setSelectedTab] = useState('headquarter');

  const [years, setYears] = useState(null);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [selectedHq, setSelectedHq] = useState('');
  const [selectedTeam, setSelectedTeam] = useState('');
  const [selectedUser, setSelectedUser] = useState(null);

  const [companyHqOptions, setCompanyHqOptions] = useState([]);
  const [HqTeamOptions, setHqTeamOptions] = useState([]);

  useEffect(() => {
    const arrYears = getYears(3, 1);
    setYears(arrYears);
  }, []);

  useEffect(() => {
    dispatch(treeDeparts());
  }, [dispatch]);

  useEffect(() => {
    if (departs) {
      //  console.log(departs, 'departs');
      const hqs = getHqDepart(departs.children);
      setCompanyHqOptions(hqs);
    }
  }, [departs]);

  const handleChangeYear = (event) => {
    setSelectedYear(event.target.value);
  };

  const handleChangeHq = (event) => {
    setSelectedHq(event.target.value);
    //팀 가져오기
    const findTeams = companyHqOptions.find(
      (hq) => hq.id === event.target.value,
    );
    console.log(findTeams, 'findTeams');
    setHqTeamOptions(findTeams.children);
  };

  const handleChangeTab = (event, newValue) => {
    setSelectedTab(newValue);
  };

  const selectedEmployee = (emp) => {
    setSelectedUser(emp);
  };

  const handleReset = () => {
    setSelectedUser(null);
    setSelectedTab('headquarter');
  };

  const handleDownExcel = () => {
    let el;
    let name;
    if (selectTab === 'headquarter') {
      el = hqTableRef;
      name = '본부별';
    } else if (selectTab === 'team') {
      el = teamTableRef;
      name = '팀별';
    } else if (selectTab === 'employee') {
      el = headTableRef;
      name = '임직원';
    }
    htmlToExcel(el.current, name);
  };

  const htmlToExcel = (tableEl, name) => {
    const wb = xlsx.utils.table_to_book(tableEl, {
      sheet: 'sheet1',
      raw: true,
    });
    xlsx.writeFile(wb, name + '.xlsx');
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', my: 2 }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start',
            alignItems: 'center',
          }}
        >
          <Box sx={{ mr: 1, minWidth: 120 }}>
            <FormControl variant="standard" fullWidth>
              <InputLabel id="selected-year-label">기준년도</InputLabel>
              <Select
                labelId="selected-year-label"
                id="selected-year"
                value={selectedYear}
                label="년도"
                onChange={handleChangeYear}
              >
                {years &&
                  years.map((item, index) => (
                    <MenuItem key={index} value={item}>
                      {item}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Box>
          {selectTab === 'headquarter' && (
            <Stack
              direction="row"
              spacing={2}
              alignItems="center"
              justifyContent="flex-start"
            >
              <Stack>
                <Typography variant="subtitle2">본부</Typography>
              </Stack>
              <Stack>
                <FormControl variant="standard" size="small" fullWidth>
                  <Select
                    variant="outlined"
                    size="small"
                    labelId="selected-hq-label"
                    id="selected-hq"
                    displayEmpty
                    sx={{ width: 240 }}
                    value={selectedHq}
                    onChange={(e) => setSelectedHq(e.target.value)}
                  >
                    <MenuItem value="">본부를 선택하세요</MenuItem>
                    {companyHqOptions &&
                      companyHqOptions.map((option) => (
                        <MenuItem key={option.id} value={option.id}>
                          {option.name}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </Stack>
            </Stack>
          )}
          {selectTab === 'team' && (
            <Stack
              direction="row"
              spacing={2}
              alignItems="center"
              sx={{
                py: 1,
              }}
            >
              <Stack>
                <Typography variant="subtitle2">본부</Typography>
              </Stack>
              <Stack>
                <FormControl variant="standard" size="small" fullWidth>
                  <Select
                    variant="outlined"
                    size="small"
                    labelId="selected-hq-label"
                    id="selected-hq"
                    displayEmpty
                    sx={{ width: 240 }}
                    value={selectedHq}
                    onChange={handleChangeHq}
                  >
                    <MenuItem value="">본부를 선택하세요</MenuItem>
                    {companyHqOptions &&
                      companyHqOptions.map((option) => (
                        <MenuItem key={option.id} value={option.id}>
                          {option.name}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </Stack>
              <Box>
                <Typography variant="subtitle2">팀</Typography>
              </Box>
              <Box>
                <FormControl variant="standard" size="small" fullWidth>
                  <Select
                    variant="outlined"
                    size="small"
                    labelId="selected-team-label"
                    id="selected-team"
                    displayEmpty
                    sx={{ width: 240 }}
                    value={selectedTeam}
                    onChange={(e) => setSelectedTeam(e.target.value)}
                  >
                    <MenuItem value="">팀을 선택하세요</MenuItem>
                    {HqTeamOptions &&
                      HqTeamOptions.map((option) => (
                        <MenuItem key={option.id} value={option.id}>
                          {option.name}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </Box>
            </Stack>
          )}

          {selectTab === 'employee' && (
            <Stack
              direction="row"
              spacing={2}
              alignItems="center"
              sx={{
                py: 1,
                borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
              }}
            >
              <Box sx={{ width: '20%', textAlign: 'center' }}>
                <Typography variant="subtitle2">임직원</Typography>
              </Box>
              <Box>
                <TextField
                  size="small"
                  required={true}
                  variant="outlined"
                  fullWidth
                  id="usrNm"
                  name="usrNm"
                  value={selectedUser?.usrNm || ''}
                  disabled
                />
              </Box>
              <Box>
                <Button
                  variant="outlined"
                  color="info"
                  onClick={showEmpDialog.onTrue}
                >
                  선택
                </Button>
              </Box>
            </Stack>
          )}
        </Box>

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start',
            alignItems: 'center',
          }}
        >
          {selectTab === 'employee' && (
            <Box sx={{ mx: 1 }}>
              <Button variant="contained" color="info" onClick={handleReset}>
                임직원 초기화
              </Button>
            </Box>
          )}
          <Box>
            <Button
              variant="contained"
              color="success"
              onClick={handleDownExcel}
            >
              엑셀 다운로드
            </Button>
          </Box>
        </Box>
      </Box>
      <Divider sx={{ my: 1 }} />
      <Box sx={{ width: '100%' }}>
        <Tabs
          value={selectTab}
          onChange={handleChangeTab}
          sx={{ borderBottom: 1, borderColor: 'divider', px: 1 }}
        >
          {TABS.map((tab) => (
            <Tab key={tab.value} value={tab.value} label={tab.label} />
          ))}
        </Tabs>
        <Box sx={{ p: 1 }}>
          {/* {TABS.map(
          (tab) =>
            tab.value === selectTab && (
              <Box key={tab.value} sx={{ p: 2, borderRadius: 1 }}>
                {tab.content}
              </Box>
            ),
        )} */}

          {selectTab === 'headquarter' && (
            <HeadquarterAccountsContainer
              selectedYear={selectedYear}
              selectedHq={selectedHq}
              tableRef={hqTableRef}
            />
          )}
          {selectTab === 'team' && (
            <TeamAccountsContainer
              selectedYear={selectedYear}
              selectedHq={selectedHq}
              selectedTeam={selectedTeam}
              tableRef={teamTableRef}
            />
          )}
          {selectTab === 'employee' && (
            <EmployeeAccountsContainer
              selectedYear={selectedYear}
              selectedUser={selectedUser}
              tableRef={headTableRef}
            />
          )}
        </Box>
        <Divider />
      </Box>
      {showEmpDialog.value && (
        <EmpModalContainer
          title="사원찾기"
          multi={false}
          open={showEmpDialog.value}
          handleClose={showEmpDialog.onFalse}
          selectedEmployee={selectedEmployee}
        />
      )}
    </Box>
  );
};
export default GroupsAccountsContainer;
